<template>
  <v-snackbar v-model="display" :color="color" top>
    {{ text }}
    <template v-slot:action="{ attrs }">
      <v-btn color="white" icon v-bind="attrs" @click="closeMessage">
        <v-icon> mdi-close </v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Toaster',
  computed: {
    ...mapState('SystemMessageStore', ['color', 'text']),
    display: {
      get () {
        return this.$store.state.SystemMessageStore.display
      },
      set () {
        return this.$store.dispatch({
          type: 'SystemMessageStore/destroyMessage'
        })
      }
    }
  },

  methods: {
    closeMessage () {
      this.$store.dispatch({ type: 'SystemMessageStore/destroyMessage' })
    }
  }
}
</script>
